import React from 'react'

import { CrownFilled, Divider, FormElementWrapper, Icon, Radio } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import { TIER_ALL, TIER_ESSENTIALS, TIER_PREMIUM } from '../subscriptionTierFilters'

// Same tier colour language as the My Models chip (SubscriptionStatusTag): teal = Essentials,
// extra-purple + crown = Premium. A custom size object skips Triangle's .cgt-icon--<size>
// wrapper class, so the svg is 16px without a CSS override.
const CROWN_SIZE = { width: '16', height: '16' }

const premiumCrown = (
  <Icon
    svgComponent={CrownFilled}
    className="subscription-tier__crown"
    color="extra-purple"
    size={CROWN_SIZE}
    notSpaced
  />
)

// `name` scopes the native radio group: the desktop dropdown and the mobile All-filters panel
// can both be mounted, and a shared name would make the browser treat them as one group.
// `selectedTier` is nullable - no tier is checked until the search really is a subscription one.
function SubscriptionTier({ selectedTier = null, onChange, name, dividerClassName = '', locale = 'en' }) {
  const sectionLabel = i18n.t('listingPage.filters.subscriptionTier.label', { ns: 'rails', lng: locale })
  const allLabel = i18n.t('listingPage.filters.subscriptionTier.all', { ns: 'rails', lng: locale })

  // Essentials/Premium are plan names, so they stay untranslated - same as the My Models chip.
  const options = [
    { value: TIER_ALL, label: allLabel },
    { value: TIER_ESSENTIALS, label: 'Essentials' },
    {
      value: TIER_PREMIUM,
      label: (
        <span className="subscription-tier__option-label">
          Premium
          {premiumCrown}
        </span>
      ),
    },
  ]

  return (
    <div className="subscription-tier">
      <FormElementWrapper title={sectionLabel}>
        <div role="radiogroup" aria-label={sectionLabel}>
          {options.map(({ value, label }) => (
            <Radio
              key={value}
              id={`${name}-${value}`}
              name={name}
              label={label}
              className="cgt-menu-item subscription-tier__radio"
              isChecked={selectedTier === value}
              onChange={() => onChange(value)}
            />
          ))}
        </div>
      </FormElementWrapper>
      <Divider customClass={dividerClassName} />
    </div>
  )
}

SubscriptionTier.propTypes = {
  selectedTier: string,
  onChange: func.isRequired,
  name: string.isRequired,
  dividerClassName: string,
  locale: string,
}

export default SubscriptionTier
